import './App.scss';
import './index.scss';

import { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { map } from 'lodash-es';
import { Provider } from 'react-redux';
import store from './Redux/store';
import {
  privateRouteMap,
  publicRouteMap,
  customerRouteMap,
  adminRouteMap,
} from './routes';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import AdminRoute from './routes/AdminRoute';
import CustomerRoute from 'routes/CustomerRoute';
import { app, db, auth } from './firebaseConfig';

import { getMessaging, getToken } from 'firebase/messaging';

// import initMessaging from '/firebase-messaging-sw';

// import initMessaging from '../public/firebase-messaging-sw'

type Props = {};

const App = (props: Props) => {
  useEffect(() => {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', (event) => {
    //     console.log('event for the service worker', event);
    //   });
    // }
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);
  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <CircularProgress
              className='loading'
              disableShrink
              color='inherit'
            />
          }
        >
          <Switch>
            {
              /* we cannot use dynamic key value here, dynamic 'key' will cause the app to
                re-render as key changes its value. To avoid that, we are here using static value
                */
              map(publicRouteMap, (route) => (
                <PublicRoute
                  key='publicRouter'
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))
            }

            {map(customerRouteMap, (route) => (
              <CustomerRoute
                key='customerRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(privateRouteMap, (route) => (
              <PrivateRoute
                key='privateRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(adminRouteMap, (route) => (
              <AdminRoute
                key='adminRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}
          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
